/**
 * FilterSheet field kit — FormField admin typography + Input/Select geometry.
 * Use with `Input` / `Select` so Filtry matches form chrome across list screens.
 */

/** Even columns across the content track (no left-stack + blank right band). */
export const FILTER_SHEET_FIELDS_ROW =
  'grid w-full min-w-0 grid-cols-[repeat(auto-fit,minmax(11.5rem,1fr))] gap-x-[var(--space-3)] gap-y-[var(--space-3)]';

/** One label + control cell. */
export const FILTER_SHEET_FIELD = 'flex min-w-0 flex-col gap-1.5';

/** Matches FormField admin `label` slot (`shared/ui/FormField`). */
export const FILTER_SHEET_LABEL =
  'text-sm font-semibold text-[var(--color-an-text)]';

/** Region title inside FilterSheetShell. */
export const FILTER_SHEET_TITLE =
  'm-0 text-sm font-semibold leading-snug text-[var(--color-an-text)]';

/** Helper / deferred-filter copy under the title. */
export const FILTER_SHEET_HINT =
  'm-0 text-xs leading-normal text-[var(--color-an-text-muted)]';
